/* global jQuery Modernizr espn_ui */
import selectn      from 'selectn'
import { COUNTRY_REGION } from '../../constants/countryToRegion'
import { BREAKS } from '../../constants/kveventsBreaks'
import { getEnvironment } from './editions'
import dateFormat       from './dateformat'
import _map from 'lodash/map'
import _compact from 'lodash/compact'
import URL from 'url'
import qs from 'query-string'
import _filter from 'lodash/filter'

/**
 * create and returns a thortted function
 * @param  {Function} callback - function to be throttled
 * @param  {Number}   limit    - milliseconds
 * @return {[type]}            thortted function
 */
export function throttle(callback, limit) {
  let wait = false
  return function () {
    if (!wait) {
      callback.call()
      wait = true
      setTimeout(function () {
        wait = false
      }, limit)
    }
  }
}

/**
 * Check if a object's property holds truthy value.(string true or boolean true)
 *
 * @param  {Object}  input input object on which property needs to be checked
 * @param  {String}  key   property name
 * @return {Boolean}       true of input[key] is truthy else false
 */
export function isPropertyTruthy(input = {}, key = '') {
  if (input) {
    if (input.hasOwnProperty(key) === false) {
      return false
    }
    //  Get the actual value
    let value = input[key]
    // Check if typeof is a boolean and equals to true
    if (typeof value === 'boolean' && value === true) {
      return true
    }
    // Check if typeof is a string and equals to 'true'
    if (typeof value === 'string' && value === 'true') {
      return true
    }
  }
  return false
}

/**
 * Check if an object is empty i.e. if it has a property
 * @param  {Object}  input input object
 * @return {Boolean}       true if object is empty else false
 */
export function isObjectEmpty(input = {}) {
  for (var k in input) {
    if (input.hasOwnProperty(k)) {
      return false
    }
  }
  return true
}

export function scrollLock(flag) {
  const scrollLockClass = 'scroll-locked'

  if (flag === true) {
    jQuery('body').addClass(scrollLockClass)
  } else {
    jQuery('body').removeClass(scrollLockClass)
  }
}

/**
 * Get player roles (e.g. captain, wicket keeper).
 * If valid return as is. Else return empty string.
 * @param  {String} name  player name
 * @param  {String} roles captain & wicket keeper roles
 * @param  {String} comma if multiple players passed
 * @return {Object}  name & roles & comma based on multiple players
 */
export function getPlayerRoles( name = '',  roles = '',  comma = '') {
  let sanitizedRoles = ''
  // default return string
  let playerRoleDisplayable = ''
  // Store name & roles & comma if available
  let playerRole = []

  if (name !== '') {
    playerRole.push(name)
  }
  // Allow only captain and wicket keeper roles.
  if (roles.indexOf('(c)') > -1  || roles.indexOf('&dagger;') > -1) {
    sanitizedRoles = roles
    // Role should have a comma after player name, else it is not readable
    playerRole.push(' ' + sanitizedRoles)
  }
  // Append comma only if passed as argument
  if (comma !== '') {
    playerRole.push(comma)
  }
  // Join only if fields are pushed to playerRole
  if (playerRole.length !== 0) {
    playerRoleDisplayable = playerRole.join('')
  }
  //console.info('playerRoleDisplayable', playerRoleDisplayable)
  return { __html : playerRoleDisplayable }
}

/**
 * Get commentary for a batsman.
 * Displays how a batsman got out or is not out
 *
 * @param  {Object} batsman       batsman details
 * @param  {Number} i             batting order number
 * @param  {Number} id            innings order number
 * @param  {Boolean} hideOutComm  true if out commentary should be hidden
 * @return {Object}         commentary markup
 */
export function getBatsmanComm(batsman = {}, i, id, hideOutComm = false) {
  // Use this flag to determine if batsman how out comms needs to be shown
  let displayMore = true
  let shortComm
  let batsmanShortText = batsman && (batsman.shortText || '')
  let isAbsentHurt = (batsmanShortText && batsmanShortText.indexOf('absent hurt') > -1) || false

  // Display Not out for a not out batsman
  if (batsman.isNotOut === true || isAbsentHurt) {
    displayMore = false
    shortComm = batsman.isNotOut === true ? 'Not Out' : batsmanShortText
  }
  // If commentary is not available or should not be shown, show only short text
  if (batsman.commentary == '' || hideOutComm) {
    displayMore = false
    shortComm = batsmanShortText
  }
  //console.info('displayMore', displayMore)

  let markup = ''
  // Display shortComm if no commentary is available
  if (displayMore === false) {
    markup = shortComm
  }
  // Else show markup of expand collapse hyperlink
  else{
    markup = `<a class="icon-font-before collapsed" role="button" data-toggle="collapse" href="#commentary-00${i+1}-${id}" aria-expanded="true" aria-controls="commentary-00${i+1}">${batsmanShortText}</a>`
  }
  return { __html : markup }
}


export function deviceType() {
  try {
    if(process.browser) {
      const media_query_in_use = espn_ui.media_query_in_use || ''
      let deviceType = { isTouch : false }

      switch(media_query_in_use) {
        case 'mobile':
          deviceType.isMobile = true
          break
        case 'tablet':
          deviceType.isTablet = true
          break
        case 'desktop':
          deviceType.isDesktop = true
          break
        case 'desktop-lg':
          deviceType.isDesktopXX = true
          break
      }

      deviceType.isTouch = Modernizr && Modernizr.touch

      return deviceType
    } else {
      // return empty Object in server rendering to avoid error
      return {}
    }
  } catch(err) {
    console.log(err)
  }
}

export function relativeDate(date) { // logic copied from sCore tea/core-tea/src/main/tea/format/util/relativeDate.tea
  let displayTime = date

  if (date instanceof Date) {
    let timeToShow = (new Date() - date.getTime()) / 60000
    let wordToShow = 'm'

    if (timeToShow <= 0) {
      timeToShow = 1
    }
    if (timeToShow >= 60) {
      timeToShow = Math.round(timeToShow / 60.0)
      if (timeToShow < 24) {
        wordToShow = 'h'
      } else {
        timeToShow = Math.round(timeToShow / 24.0)
        wordToShow = 'd'
      }
    }
    displayTime = Math.round(timeToShow) + wordToShow
  }

  return displayTime
}

export const isGeoRestricted = (geoRestrictions = {}, userCountry) => {
  const type = geoRestrictions.type || ''
  const countries = geoRestrictions.countries || []
  if(!(userCountry && type && countries.length)) {
    return type === 'whitelist'
  }
  if(countries.indexOf(userCountry) !== -1) {
    return type === 'blacklist'
  } else {
    return type === 'whitelist'
  }
}

/**
 * To show or restrict video with certain copyright text in site, domain or app
 * @param  {Object} copyRightText Text for copyright
 * @param  {Object} config        options for geo, webview, edition etc
 * @return {Boolean}              to show or not
 */
export const showCopyrightVideo = (copyRightText = {}, config = {}) => {
  const { isWebView, site, userGeo, domain } = config
  var toShow = true
  var isEspnInApp = false
  var isEspnInWeb = false

  copyRightText = copyRightText ? (copyRightText.bundle ? copyRightText.bundle.toLowerCase(): '') : {}

  if(isWebView && site === 'espn' && userGeo === 'in') {
    isEspnInApp = true
  }else if(site === 'espn' && domain === 'www.espn.in') {
    isEspnInWeb = true
  }

  //video with copyright text 'sony_rights_content' only to show in ESPN India website and ESPN India app
  if(copyRightText === 'sony_rights_content' ) {
    if((isEspnInApp || isEspnInWeb)) {
      toShow = true
    }else{
      toShow = false
    }
  }

  return toShow
}

export function getScorePageType(location = {}, scoreboardType) {
  const query = location.query
  let defaultDate = new Date()
  let scorePageType = 'scoreboard'
  if( scoreboardType === 'default') {
    scorePageType = 'liveindex'
  }
  if(query.date && scoreboardType === 'default') {
    if(dateFormat.dateToObject(query.date || '').setHours(0,0,0,0) > defaultDate.setHours(0,0,0,0)) {
      scorePageType = 'fixtures'
    } else if(dateFormat.dateToObject(query.date || '').setHours(0,0,0,0) < defaultDate.setHours(0,0,0,0)) {
      scorePageType = 'results'
    }
  }
  return scorePageType
}

export function hasRouteChanged(location = {}, newLocation = {}) {
  const currentPath = location.pathname + location.search
  const changedPath = newLocation.pathname + newLocation.search
  if(changedPath === currentPath) {
    return false
  }else{
    return true
  }
}

export function hasStandingChanged(leagueId = '', currleagueId = '', season ='', currentSeason = '') {
  if(leagueId === currleagueId && season === currentSeason) {
    return false
  }else{
    return true
  }
}


/**
 * Enables polling data in a container
 * @param  {Array}  actions actions
 * @return {void}
 */
export function poll(actions = []) {
  const { dispatch, polling = {}, appProps } = this.props
  const { enabled, duration } = polling
  if(this.timer === null && enabled === true) {
    this.timer = window.setInterval((() => {
      // Run a route change check with window.location
      // This prevents polling in the background after,
      // if user has moved outside of a React page
      const { edition, location, params, polling = {} } = this.props
      if(!hasRouteChanged(location, window.location) && polling.enabled) {
        actions.map(action => {
          dispatch(action({ edition, params, location, isPolling : true, appProps }))
        })
      }else {
        //console.info(`cleared timer: ${params.pageType}`)
        window.clearInterval(this.timer)
        this.timer = null
      }
    }).bind(this), duration)
  }
}

export const urlWithParams = function (url = '') {
  return url + (url.indexOf('?') === -1 ? '?' : '&') + Array.prototype.slice.call(arguments).slice(1).join('&')
}
/**
 * This method will return appropriate reducer mapping
 * @param {string} template template name
 * @return {string} reducer name
 */
export function mapTemplateToReducer(template) {
  const map = {
    'gamepackage' : 'gamePackage',
    'gamepackage-webview-ios' : 'gamePackage',
    'gamepackage-webview-android' : 'gamePackage'
  }
  return map[template] || template
}

/**
 * Get class name for a ball by ball commentary event
 * @param  {String} event as received from the commentary
 * @return {String}       class name which will be used by components
 */
export function getBallClass(event = '') {
  // array to hold all class names
  let allClasses = [ 'over-circle' ]
  // default value of class name for a ball
  let eventClassName = 'low-score'

  if(event === 'W') {
    eventClassName = 'wicket'
  }else if(event >= 4) {
    eventClassName = 'high-score'
  }
  // Append required class name to array and create final string
  allClasses.push(eventClassName)
  let classString = allClasses.join(' ')

  return classString
}


export function isCurrentLeague(startDate, endDate, currDate) {
  let isCurrent = false
  if (currDate > startDate && currDate < endDate ) {
    isCurrent = true
  } else {
    isCurrent = false
  }
  return isCurrent
}

export function getYearDropDown() {
  let currYear = new Date().getFullYear()
  let startYear = currYear - 6
  let yearFliter = []

  for(let i =currYear ; i > startYear; i--) {
    yearFliter.push(
      {
        name: i,
        text: i
      }
    )
  }
  return yearFliter
}

/*!
 *
 * Copyright (c) 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative
 * Reporters & Editors

 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * Returns a function that is the composition of a list of functions, each
 * consuming the return value of the function that follows.
 * @return {Function} composed function
 */
export function compose() {
  var args = arguments
  var start = args.length - 1
  return function () {
    var i = start
    var result = args[start].apply(this, arguments)
    while (i--) result = args[i].call(this, result)
    return result
  }
}

/**
 * get connection speed
 * @param  {Object} req request object
 * @param {Object} routeParams object
 * @param {String} template (gamepackage)
 * @return {String} connectionspeed (data-lite|full)
 */
export function getConnectionSpeed(req = {}, routeParams = {}, template = '') {
  const query = req.query || {}
  const connectionSpeeds = [ 'data-lite', 'full' ]
  let connectionSpeed = 'full'

  // by default force cric app to use data-lite
  if(isCricAppWebView(req, routeParams, template)) {
    connectionSpeed = 'data-lite'
  }

  // for debugging and testing, let people force data-lite or full via query param
  let tmpConnectionSpeed = query.connectionspeed
  if(connectionSpeeds.indexOf(tmpConnectionSpeed) !== -1) {
    connectionSpeed = tmpConnectionSpeed
  } else if(isDataLiteEligible(req, routeParams)) { // if user isn't forcing a connectionSpeed, and if the site can use data-lite, use connectionSpeed from headers in avai'able
    tmpConnectionSpeed = req.headers && req.headers['x-connectionspeed'] || connectionSpeed
    if(connectionSpeeds.indexOf(tmpConnectionSpeed) !== -1) {
      connectionSpeed = tmpConnectionSpeed
    }
  }
  return connectionSpeed
}

const dataLiteCountries = [ 'in', 'pk', 'lk', 'bd' ]
const dataLiteSites = [ 'espncricinfo' ]

/*
 * only users with specific site / country values will be eligble to view data-lite version of site
 * should follow the same logic in sCore, as defined (https://goo.gl/Fksd1m)
*/
export function isDataLiteEligible(req = {}, routeParams = {}) {
  let { site, userGeo: country } = req.edition
  const isWebView  = routeParams.webview

  if(!country) {
    console.warn('user country not detected, falling back to edition country')
    country = req.edition.country
  }
  return dataLiteCountries.indexOf(country) !== -1 && dataLiteSites.indexOf(site) !== -1 && !isWebView
}

export function isCricAppWebView(req = {}, routeParams = {}, template = '') {

  const query = req.query || {}
  const { appsrc, appName } = query
  const editionHost = query['edition-host']
  const { platform } = routeParams
  const environment = getEnvironment(req)
  const cricAppDataLiteEnvironments = [ 'qa', 'dev', 'local' ]
  const device = getDevice(req)
  const isAppLite = getAppType(device, req.edition)
  if(typeof template !== 'undefined') {
    if(!isAppLite && cricAppDataLiteEnvironments.indexOf(environment) !== -1 && template.indexOf('gamepackage') === 0) {
      if (appsrc === 'cricinfo') { // future iOS builds of CricInfo after 5.01
        return true
      } else if ((appsrc === 'sc') && editionHost === 'espncricinfo.com') { // current iOS build for CricInfo app
        return true
      } else if ((platform === 'android' || platform === 'ios') && editionHost === 'espncricinfo.com') { // Android CricInfo article XHR and game pages
        return true
      } else if (platform === 'android' && appName === 'cricinfo') { // Android static shell for article pages
        return true
      }
    }
  }

  return false
}

/**
 * get site type alias for getConnectionSpeed
 * @param  {Object} req request object
 * @return {String} siteType (data-lite|full)
 */
export const getSiteType = getConnectionSpeed

/**
 * get device type
 * @param  {Object} req request object
 * @return {String}     device type
 */
export function getDevice(req) {
  const query = req.query || {}
  let device = query.device || req.headers && req.headers['x-device'] || 'desktop'

  // porting existing Tea logic
  // TODO: detection based on cookie for non varnish (local) requests
  if(device == 'pc' || device == 'tv') {
    device = 'desktop'
  }
  else if(device == 'mobile-smartphone' || device == 'handset') {
    device = 'mobile'
  }
  else if(device == 'mobile-generic') {
    device = 'featurephone'
  }
  else if(device == 'pc-generic') {
    device = 'featurephone'
  }

  if(device != 'tablet' && device != 'mobile' && device != 'featurephone') {
    device = 'desktop'
  }
  return device
}

export function getAppType(device = '', edition = {}) {
  const host = edition.host || ''
  const liteAppHosts = [ 'espncricinfo.com', 'espncricinfosb.com' ]

  if(device === 'featurephone' && liteAppHosts.indexOf(host) >= 0) {
    return true
  } else {
    return false
  }
}
/**
   * Get hostInfo from editions
   * Returns hostInfo based on host in editions
   * @param {String} host host
   * @return {String} hostInfo
  */
export function getHostInfo(host) {
  let hostInfo = 'ESPN'
  if(host && typeof host === 'string') {
    switch (host.toLowerCase()) {
      case 'espncricinfo.com' :
        hostInfo = 'ESPNCricinfo'
        break
      case 'espncricinfosb.com' :
        hostInfo = 'ESPNCricinfo'
        break
      default :
        hostInfo = 'ESPN'
    }
  }
  return hostInfo
}

/**
 * Function to pick correct mockData and return as response
 * @param {Object} appProps app properties with file name
 * @return {Object} res response
 */
export function fetchMockData(appProps) {
  let res = {}
  let fileName = appProps && appProps.fileName
  let dataType = appProps && appProps.dataType
  if(fileName && (dataType === 'mock')) {
    let mockData = require('../../../mock-data/'+fileName)
    res = { dataType: dataType, data: mockData }
  }
  return res
}

/**
 * Helper function that triggers a callback when the given library is loaded
 * @param  {String}   namespace Namespace of the library
 * @param  {Object}   cntx      Context on which library would be mounted
 * @param  {Number}   interval  Interval b/w recursive call
 * @param  {Function} callback  Callback function (use Arrow function or function(){}.bind(this) if Fn definition uses 'this' operator)
 * @return {undefined}
 */
export function isLibraryLoaded({ namespace, cntx = window, interval, callback }) {
  let timer

  if (typeof namespace !== 'string' || typeof callback !== 'function' || (cntx && typeof cntx !== 'object')) {
    return
  }

  // set default time interval
  if (isNaN(interval)) {
    interval = parseInt(interval, 10)

    if (isNaN(interval)) {
      interval = 300
    }
  }

  const checkNamespace = function checkNamespace() {
    window.clearTimeout(timer)
    try {
      if (typeof cntx[namespace] !== 'undefined') {
        callback()
      } else {
        timer = window.setTimeout(checkNamespace, interval)
      }
    } catch(err) { console.error(err) }
  }

  // init
  checkNamespace()
}


export function getCountrySupportedRegion( country ) {
  let region = ''
  if ( typeof country === 'string' ) {
    region = COUNTRY_REGION[ country ] || region
  }
  //console.info('region', region)
  return region
}


/**
   * Get isEspnCricinfo from host
   * Returns isEspnCricinfo based on host
   * @param {String} host host
   * @param {String} editionKey editionKey
   * @return {String} isEspnCricinfo
  */
export function isEspnCricinfo(host, editionKey) {
  let isEspnCricinfo = false
  const key = host + ' ' + editionKey
  if(key && typeof key === 'string' && key.indexOf('espncricinfo') > -1) {
    isEspnCricinfo = true
  }
  return isEspnCricinfo
}

/**
   * List supported bet365 kiosk ad editions
   * @param  {Object} edition  edition object
   * @return {Boolean}  true if bet365 kiosk should appear for passed edition
  */
export function isBet365KioskEdition(edition = {}) {
  let supportedEditions = {
    'espnww-en': true,
    'espnuk-en': true,
    'espnau-en': true
  }
  return supportedEditions[edition.editionKey] ? true : false
}

/**
 * Get 2nd MPU index value on RHS gamepackage module
 * @param  {Integer} highlightsVideoCount  heighlight counts
 * @param  {Object} standings object
 * @param  {Object} matchcards object
 * @param  {Object} news object
 * @return {Integer}  Index value
 */
export function getMpuIndex( highlightsVideoCount = 0, standings = {}, matchcards = {}, news = {}) {
  let newsCount = news.items ? news.items.length : 0
  let matchcardsCount = matchcards.length
  let standingsCount = standings.teams ? standings.teams.length : 0

  if(highlightsVideoCount > 0) {
    return 4
  } else if(newsCount > 0) {
    return 5
  } else if(matchcardsCount > 0) {
    return 6
  } else if(standingsCount > 0) {
    return 7
  }
}

/**
 * Get 3rd MPU index value on RHS gamepackage module
 * Relying on component key in the array to determine if it is an actual module of game package or an ad
 * Checks until the native1 ad to figure out how many GP modules exist after 2nd MPU
 * @param  {Array} columnThree  heighlight counts
 * @param  {Integer} mpu2Index object
 * @return {Integer} Returns undefined if the number of GP modules are less than 3 or The index value to insert mpu3
 */
export function getMpu3Index( columnThree = [], mpu2Index) {
  let noOfGpModulessAfterMpu2 = 0, col3length = columnThree.length
  const adModuleKeys = [ 'adinstr','ad','promoad' ]

  for(let i=mpu2Index+1; i <= col3length; i++) {
    let currElement = columnThree[i]
    let currElementKey = currElement && currElement.key
    if(typeof currElement === 'undefined' ||
        typeof currElementKey === 'undefined' ||
        !currElementKey || adModuleKeys.includes(currElementKey)) {
      continue
    } else if(currElementKey === 'native1') {
      if(noOfGpModulessAfterMpu2 == 3) {
        return i
      }
    } else {
      noOfGpModulessAfterMpu2++
    }
  }
  return
}

export function getTrackingImg(edition = {} , pageType = '', leagueName = '', slug = '', gameId, location, siteType = '', gameState = '', query, teams = {}, scoreboardType) {
  const isDataLite = (siteType === 'data-lite') ? true : false
  let checkQaRegExp = /((qa|local|localhost|sb|preview|dev2|127.0.0.1)\.|useqa=true|enable=(qaAPI|sbAPI))/i
  let locationHref = (typeof window !== 'undefined') ? (window.location && window.location.href) : ''
  let account = (checkQaRegExp.test(locationHref)) ? 'wdgespncomdev' : 'wdgespcricinfo,wdgespge'
  let site ='cricinfo'
  let host ='https://sw88.espn.com'
  let version ='/1/JS-1.6.1/s'
  let server = edition.host || 'www.espn.com'
  let time = Date.now()
  let noCookies = 'Cookies Not Supported'
  let omniParamString = ''
  let sport = 'cricket'
  let namespace = 'espn'
  let charset = 'ISO-8859-1'
  let currencyCode = 'USD'
  let cookieDomainCode = '2'
  let strParams = ''
  let nSite = site
  let featurephoneTxt = 'Feature+Phone'
  let pageTypeTxt = ''
  let section = ''
  let pagename = ''
  let events = 'event3'
  let ex_cid = query['ex_cid'] || ''
  let leagueSlug = slug || leagueName
  leagueSlug = leagueSlug && leagueSlug.replace(' ', '-').toLowerCase()
  const { home = {}, away = {} } = teams
  let homeTeam = home.name || ''
  let awayTeam = away.name || ''
  let gameInfo = (homeTeam.length > 0 || awayTeam.length > 0) ? `${homeTeam} vs ${awayTeam}` : leagueSlug
  gameInfo = gameInfo && gameInfo.toLowerCase()
  pageType = (pageType === 'scores') ? 'scoreboard' : pageType

  switch(pageType) {
    case 'table':
    case 'standings':
      pageTypeTxt = 'standings'
      pagename = site + ':' + leagueSlug + ':' + pageTypeTxt
      section = site + ':' + leagueSlug
      break
    case 'scoreboard':
      pageTypeTxt = pageType
      gameInfo = gameInfo === '' ? 'no+league' : gameInfo
      switch(scoreboardType) {
        case 'default':
          pagename = site + ':' + pageType + ':' + 'index'
          section = site + ':' + pageType
          break
        case 'team':
          pagename = site + ':' + slug + ':' + pageType
          section = site + ':' + slug
          break
        case 'series':
          pagename = site + ':' + leagueSlug + ':' + pageType
          section = site + ':' + leagueSlug
          break
      }
      break
    case 'game':
      pageTypeTxt = 'game'
      switch(gameState) {
        case 'in':
          pageType = 'live'
          break
        default:
          pageType = 'summary'
      }
      pagename = site + ':' + gameInfo + ':' + pageTypeTxt + ':' + pageType
      section = site + ':' + leagueSlug
      break
  }

  if(isDataLite) {
    nSite = site + ':lite'
    featurephoneTxt = ''
    events = 'event3,event20'
  }

  if(edition.isEspnCricinfo && location.indexOf('/cricket/') > -1) {
    location = location.replace('/cricket/','/')
  }

  let omniData = {
    'c1' : nSite,
    'ch' : section,
    'c2' : 'D=SWID',
    'c5' : pagename,
    'c6' : noCookies,
    'c16' : edition.countryName,
    'v12' : edition.countryName,
    'v14' : gameId + '+' + gameInfo,
    'c14' : gameId + '+' + gameInfo,
    'c24' : noCookies,
    'c37' : featurephoneTxt,
    'v37' : featurephoneTxt,
    'pageName' : pagename,
    'v13' : pagename,
    'h1' : pagename,
    'c30' : 'N',
    'v19' : sport,
    'g' : location,
    'c17' : edition.language,
    'v9' : edition.language,
    'c4' : 'match',
    'c25' : sport,
    'v69' : gameState,
    'v11' : pagename,
    'c26' : leagueSlug,
    'v21' : leagueSlug,
    'events' : events,
    'v0' : ex_cid
  }

  for (var key in omniData) {
    if (omniData.hasOwnProperty(key)) {
      if(encodeURIComponent(omniData[key] )) {
        omniParamString += '&' + key + '=' + encodeURIComponent(omniData[key])
      }
    }
  }

  let trackLinkParam = {
    'AQB' : 1,
    'ndh' : 1,
    'server' : server,
    'ns' : namespace,
    'ce' : charset,
    'cc' : currencyCode,
    'cdp' : cookieDomainCode + omniParamString,
    'AQE' : 1
  }

  for (var k in trackLinkParam) {
    if (trackLinkParam.hasOwnProperty(k)) {
      strParams += k + '=' + trackLinkParam[k] + '&'
    }
  }


  let trackingUrl = `${host}/b/ss/${account}${version}${time}?${strParams}`

  return trackingUrl
}
/** Get isEspnCricinfoIn from editions
   * Returns isEspnCricinfoIn based on host in editions
   * @param  {Object} edition edition object
   * @return {Boolean} isEspnCricinfoIn
  */
export function isEspnCricinfoIn(edition = {}) {
  let isEspnCricinfoIn = false
  if( edition.isEspnCricinfo && edition.country === 'in' ) {
    isEspnCricinfoIn = true
  }
  return isEspnCricinfoIn
}

/**
 * show buttom ads for different tabs of gamepackage page
 * @param  {String} pageType different pagetypes
 * @return {Boolean}          return true/false if report/video/coverage/standings page
 */
export function showBottomAdModule(pageType = '') {
  let showBottomAds = false
  let pageList = [ 'report', 'video', 'coverage', 'standings', 'table' ]
  if(pageList.indexOf(pageType) > -1) {
    showBottomAds = true
  }
  return showBottomAds
}

export function getBet365Odds(oddsNode = {}, oddsArray = [], device = {}, pageType = '') {
  let items = {}
  if(pageType === 'gamepackagemodule') {
    const teamOdds = oddsArray || []

    for(let oddNode of teamOdds) {
      let oddType = selectn('type', oddNode) || ''
      let  oddDetails = {}

      switch(oddType.toLowerCase()) {
        case 'towin':
          oddDetails = getToWinOdds(oddNode, device)
          break
        case 'manofthematch':
          oddDetails = getManOfTheMatchOdds(oddNode, device)
          break
        case 'towinthetoss':
          oddDetails = getToWinTheToss(oddNode, device)
          break
        case 'playerdismissalmethod':
          oddDetails = getPlayerDismissalMethodOdds(oddNode, device)
          break
        case 'drawnobet':
          oddDetails = getDrawNoBetOdds(oddNode, device)
          break
      }

      items[oddType] = oddDetails
    }
  } else {
    const teamOdds = oddsNode || {}
    const links = selectn('links', teamOdds) || []
    const oddTypes = [ 'homeTeamOdds', 'awayTeamOdds', 'drawOdds' ]
    let linkMap = getBetLink(links, device)
    let filterLink = {}

    for(let link of linkMap) {
      filterLink[link.text] = link
    }

    for(let oddType of oddTypes) {
      let odd = teamOdds[oddType]

      if(typeof odd !== 'undefined') {
        if(oddType === 'drawOdds') {

          items.Draws = {
            'summary': selectn('summary', odd),
            'href': selectn(`${oddType}.href`,filterLink)
          }
        } else {
          let team = selectn('team.abbreviation', odd) || selectn('team.displayName', odd) || ''
          if(device && device.desktop == true && pageType === 'gamepackagemodule') {
            team = selectn('team.displayName', odd) || ''
          }

          if (team === '') {
            continue
          }

          items[team] = {
            'summary': selectn('odds.summary', odd),
            'href': selectn(`${oddType}.href`,filterLink)
          }
        }

      }
    }
  }
  return {
    items
  }
}

export function getBetLink(links = [], device = {}) {
  let linkMap = []
  let deviceType = 'desktop'

  if(device && device.mobile == true) {
    deviceType = 'mobile'
  }

  let filterLinks  = links.length && _filter(links, function (link) {
    return (link && (link.rel.indexOf(deviceType) > -1))
  })

  linkMap = filterLinks.length ? filterLinks : links

  return linkMap
}

export function getToWinOdds(oddNode = {}, device = {}) {
  let items = {}
  const links = selectn('links', oddNode) || []
  const oddTypes = [ 'homeTeamOdds', 'awayTeamOdds', 'drawOdds' ]

  let linkMap = getBetLink(links, device)
  let filterLink = {}

  for(let link of linkMap) {
    filterLink[link.text] = link
  }

  for(let oddType of oddTypes) {
    let odd = oddNode[oddType]

    if(typeof odd !== 'undefined') {
      if(oddType === 'drawOdds') {

        items.Draws = {
          'summary': selectn('summary', odd),
          'href': selectn(`${oddType}.href`,filterLink)
        }
      } else {
        let team = selectn('team.abbreviation', odd) || selectn('team.displayName', odd) || ''
        if(device && device.desktop == true) {
          team = selectn('team.displayName', odd) || ''
        }

        if (team === '') {
          continue
        }

        items[oddType] = {
          'displayName': team,
          'teamAbbrev': selectn('team.abbreviation', odd),
          'summary': selectn('odds.summary', odd),
          'href': selectn(`${oddType}.href`,filterLink)
        }
      }
    }
  }
  return items
}

export function getToWinTheToss(oddNode = {}, device = {}) {
  let items = {}
  const odds = selectn('winTheTossoOdds', oddNode) || []

  for(let odd of odds) {
    const link = selectn('links.[0].rel', odd) || []
    const oddType = link.includes('home') ? 'home' : link.includes('away') ? 'away' : ''
    const links = odd.links
    let linkMap = getBetLink(links, device) || []

    items[oddType] = {
      'displayName': selectn('team.displayName', odd),
      'teamAbbrev': selectn('team.abbreviation', odd),
      'summary': selectn('odds.summary', odd),
      'href': selectn('[0].href', linkMap)
    }
  }
  return items
}

export function getManOfTheMatchOdds(oddNode = {}, device = {}) {
  let items = []
  const players = selectn('playerOfTheMatchOdds', oddNode) || []

  for(let player of players) {
    const links = player.links
    let linkMap = getBetLink(links, device) || []
    items.push({
      name: selectn('athlete.displayName', player),
      summary: selectn('odds.summary', player),
      href: selectn('[0].href', linkMap)
    })
  }

  return items
}

export function getBet365Nbo(situationNode = [], device = {}) {
  const oddsNode = situationNode.odds || []
  let items = {}

  for(let odd of oddsNode) {
    const athlete = selectn('nextBatsmanOut.athlete.name', odd) || ''

    if (athlete == '') {
      continue
    }
    const links = odd.links
    let linkMap = getBetLink(links, device) || []

    items[athlete] = {
      'summary': selectn('nextBatsmanOut.odds.summary', odd),
      'href': selectn('[0].href', linkMap)
    }
  }

  return {
    text: selectn('[0].links[0].text', oddsNode),
    items
  }
}

export function getPlayerDismissalMethodOdds(oddNode = {}, device = {}) {
  let items = {}
  const methods = selectn('playerDismissalMethodOdds', oddNode) || []

  for(let method of methods) {
    const methodName = selectn('dismissalMethod', method) || {}
    const methodType = methodName.displayName.startsWith('Caught') ? 'Caught' : 'Not Caught'
    const links = method.links
    let linkMap = getBetLink(links, device) || []

    items[methodType] = {
      'summary': selectn('odds.summary', method),
      'href': selectn('[0].href', linkMap)
    }
  }
  return items

}

export function getDrawNoBetOdds(oddNode = {}, device = {}) {
  let items = {}
  const teams = selectn('drawNoBetOdds', oddNode) || []

  for(let team of teams) {
    const teamName = selectn('team.displayName', team) || {}
    const links = team.links
    let linkMap = getBetLink(links, device) || []

    items[teamName] = {
      'summary': selectn('odds.summary', team),
      'href': selectn('[0].href', linkMap)
    }
  }
  return items

}

export function getBet365(oddsNode = {}, oddsArray = [], site = '', situationNode = {} , gameState = '', device = {}, userGeo = '') {
  let odds = getBet365Odds(oddsNode, oddsArray, device)
  let moduleOdds = getBet365Odds(oddsNode, oddsArray, device, 'gamepackagemodule')
  let situationNodeOdd = {}
  if(situationNode) {
    situationNodeOdd = getBet365Nbo(situationNode, device)
  }
  // dont show bet365 if user country is unknown from varnish
  let showInGeo = userGeo && userGeo=='UNKNOWN' && false
  return {
    // 'showInEdition' flag decided by edition and match state
    showInEdition: true,
    // 'showInGeo' decided by geo location
    showInGeo,
    defaultMsg: 'In-play betting with bet365.',
    defaultLink: 'https://www.bet365.com/olp/cricket?affiliate=365_307576&',
    odds,
    moduleOdds,
    situationNodeOdd,
    gameState,
    site
  }
}

export function getUpdatedAffiliateCode(link = '', affiliateCodeOverwrite) {
  let queryParam = link.indexOf('affiliatecode=') > -1 ? 'affiliatecode=' : 'affiliate='
  let regex = new RegExp('(' + queryParam + ').*?(&|\")')
  return link.replace(regex,'$1' + affiliateCodeOverwrite + '$2')
}

/**
 *
 * @param {String} url canonical url
 * @return {String}    canonical url without '/cricket' for editions
 */
export function getCricketCanonical(url, domain) {
  let canonical = ''
  if(url.indexOf('/cricket/') > -1 && domain.indexOf('.espn.') == -1) {
    canonical = url.replace('/cricket', '')
  }
  return (canonical || url)
}
/**
 * [redirectToCanonical Redirect to the canonical page, if slug is different]
 * @param  {String} canonical  [correct canonical link]
 * @param  {Object} reqOptions [request url options]
 * @return {Object}            [return allow redirect flag, redirect URL]
 */
export function redirectToCanonical(canonical, reqOptions) {
  const { url, slug, host, platform, device, sport } = reqOptions
  let _slug_ = false
  const noRedirect = (platform || (device === 'featurephone')) ? true : false
  const defaultRedirOptions = { allow: false, href: undefined, path: undefined, _slug_: _slug_ }
  let reqUrl = url

  if (!noRedirect) {

    //fix for _slug_ in rugby team pages
    if(RegExp('_slug_=').test(reqUrl) && (sport === 'rugby' || sport === 'nrl')) {
      let qsObj = qs.parse(reqUrl)
      qsObj._slug_ = slug
      reqUrl = Object.keys(qsObj).map(key => key + '=' + qsObj[key]).join('&')
      _slug_ = true
    }

    const reqUrlObj = URL.parse(reqUrl) || {}
    const reqCanonicalObj = URL.parse(canonical) || {}
    const query = reqUrlObj && reqUrlObj.query || ''
    let redirectFullPath = [ 'http://', host, canonical ].join('')
    //set default redirect URL till pathname
    let redirectHref = redirectFullPath
    let redirectPath = canonical
    //keep query params
    if (query) {
      redirectHref = [ redirectFullPath, '?', query ].join('')
      redirectPath = [ redirectPath , '?', query ].join('')
    }

    //check if slug is different
    let sendTempRedirect = (reqUrlObj.pathname !== reqCanonicalObj.pathname) ? true : false

    if(sport === 'rugby' || sport === 'nrl') {
      sendTempRedirect = false
    }

    //do not redirect espn.in / kwese / espn.co.uk cricket pages. It will use canonical of espncricinfo.com
    //therefore, no need for correcting the slug
    if((sport === 'cricket') && (host.indexOf('espncricinfo') === -1)) {
      sendTempRedirect = false
    }

    if(sendTempRedirect) {
      return { allow: sendTempRedirect, href: redirectHref, path: redirectPath, _slug_: _slug_ }
    }else{
      return defaultRedirOptions
    }

  }

  return defaultRedirOptions

}

/**
 * Function checks the param type for preventing XSS
 * @param {Object} renderProps Params gameId, leagueId etc.
 * @return {Boolean} true or false
 */
export function hasValidPageParams(renderProps) {

  const { params, location } = renderProps
  const query =  location && location.query || {}

  let isValid = true
  let paramsArr = []
  let paramsArrLen
  let validParamsArr = []

  //params to be considered numeric
  const numParams = {
    gameId: params && params.gameId,
    league: params && params.league,
    team: params && params.team,
    season: params && params.season,
    date: query && query.date
  }

  paramsArr = _map(numParams, function (val, key) {
    let item = {}
    item[key] = val
    return (val !== undefined) ? item : null
  })
  paramsArr = _compact(paramsArr)
  paramsArrLen = paramsArr && paramsArr.length
  if (paramsArrLen > 0) {
    //console.log('paramsArr => ', paramsArr)

    for (let i = 0; i < paramsArrLen; i++) {
      let item = paramsArr[i]
      //console.log('item => ', item)
      Object.values(item).forEach(function (i) {
        //console.log('this test is ', (/^[0-9]*$/g).test(i))
        validParamsArr.push((/^[0-9]*$/g).test(i))
      })
      //console.log('validParamsArr => ', validParamsArr)
    }
  }

  if (validParamsArr.indexOf(false) > -1) {
    isValid = false
  }

  return isValid


}
/**
 * Function to check if a page / tab is hidden or active tab
 * @return {Boolean} returns true or false
 */
export function isPageHidden() {
  return document.hidden || document.msHidden || document.webkitHidden || document.mozHidden || document.visibilityState === 'hidden' || document.webkitVisibilityState === 'hidden'
}

export function loadScript(src, id) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.id = id
    script.type = 'text/javascript'
    script.async = true
    script.onload = resolve
    script.onerror = reject
    script.integrity = ''
    const fs = document.getElementsByTagName('script')[0]
    fs.parentNode.insertBefore(script, fs)
  })
}

export function generateEventsTeam(updatedProps) {
  let kvbattingteam = '',
    allInningsLength = 0,
    selectedTeam = '',
    allInnings = updatedProps && updatedProps.allInnings

  const sport = selectn('params.sport', updatedProps) || ''
  if (sport === 'cricket') {
    allInningsLength = allInnings && allInnings.length
    if (allInningsLength !== 0) {
      selectedTeam = selectn(`allInnings[${allInningsLength-1}].teamDisplayName`, updatedProps) || ''
      kvbattingteam = (selectedTeam) ? selectedTeam.replace(/\s/g, '').toLowerCase() : ''
    }
  }

  return kvbattingteam
}

export function generateScoreEvent(currentScore, updatedScore) {
  let event = '';

  [ 100,200,250,300,325,350,400 ].forEach(item => {
    if (currentScore < item && updatedScore >= item) {
      event = `team${item}`
    }
  })

  return event
}

export function generateWicketEvent(updatedWickets) {
  let event = ''

  if ( [ 3,5,8 ].indexOf(updatedWickets) !== -1 ) {
    event = `wickets${updatedWickets}`
  } else {
    event = 'wicket'
  }

  return event
}

export function generateGameStatusEvent(currentGameStatusText, updatedGameStatusText) {
  if (currentGameStatusText && currentGameStatusText === updatedGameStatusText) {
    return ''
  } else {
    return updatedGameStatusText && BREAKS[updatedGameStatusText]
  }
}

export function generateEvents(currentProps, updatedProps) {
  let kvevent = '',
    selectedInnings = 0,
    selectedInningsKey = '',
    currentBrief = {},
    updatedBrief = {},
    currentRuns = 0,
    updatedRuns = 0,
    currentWickets = 0,
    updatedWickets = 0,
    currentFours = 0,
    updatedFours = 0,
    currentSixes = 0,
    updatedSixes = 0,
    currentLiteBatsmen = [],
    updatedLiteBatsmen = [],
    updatedBatsmanPlayerId = '',
    selectedBatsman = {},
    currentBatsmanRuns = 0,
    updatedBatsmanRuns = 0,
    currentGameStatusText = '',
    updatedGameStatusText = '',
    currentPropsAllInningsLength = 0,
    updatedPropsAllInningsLength = 0,
    recentOverScore = 0,
    scoreDiff = 0

  const sport = selectn('params.sport', updatedProps) || '',
    lastOver = selectn('innings.recentOvers[0]', updatedProps) || []

  updatedPropsAllInningsLength = updatedProps.allInnings && updatedProps.allInnings.length
  selectedInnings = updatedPropsAllInningsLength - 1
  selectedInningsKey = `allInnings[${selectedInnings}].stats.brief`
  updatedBrief = selectn(selectedInningsKey, updatedProps) || {}
  updatedLiteBatsmen = selectn('innings.liteBatsmen', updatedProps) || []
  updatedGameStatusText = updatedProps.gameStatusText || ''

  updatedWickets = updatedBrief.wickets || 0
  updatedRuns = updatedBrief.runs || 0
  updatedFours = updatedBrief.fours || 0
  updatedSixes = updatedBrief.sixes || 0

  if (sport === 'cricket') {
    if (!Object.keys(currentProps).length === true) {
      recentOverScore = lastOver.reduce((accumulator, a) => {
        if (typeof a === 'number') {
          accumulator += a
        }
        return accumulator
      }, 0)
      scoreDiff = updatedRuns - recentOverScore

      lastOver.forEach((ball) => {
        if (ball === 4) {
          kvevent = 'four'
        } else if (ball === 6) {
          kvevent = 'six'
        } else if ((/^w$/i).test(ball)) {
          kvevent = generateWicketEvent(updatedWickets)
        }
      })

      kvevent = generateScoreEvent(scoreDiff, updatedRuns) || kvevent

      kvevent = generateGameStatusEvent('', updatedGameStatusText) || kvevent
    } else {
      currentGameStatusText = currentProps.gameStatusText || ''
      currentPropsAllInningsLength = currentProps.allInnings && currentProps.allInnings.length

      // If allinnings in updated props are empty then return kvevents to avoid breakdown
      if (updatedPropsAllInningsLength === 0) {
        return kvevent
      }

      /**
      * If allinnings length in updated props is equal to allinnings length in current props
      * get the currentBrief & currentLiteBatsmen from current props
      */
      if(currentPropsAllInningsLength === updatedPropsAllInningsLength) {
        currentBrief = selectn(selectedInningsKey, currentProps) || {}
        currentLiteBatsmen = selectn('innings.liteBatsmen', currentProps) || []
      }

      /**
      * If allinnings length in updated props is not equal to allinnings length in current props
      * then set the currentBrief & currentLiteBatsmen to defaults as its not available in current props
      */
      if(currentPropsAllInningsLength !== updatedPropsAllInningsLength) {
        currentBrief = {}
        currentLiteBatsmen = []
      }

      currentRuns = currentBrief.runs || 0
      currentWickets = currentBrief.wickets || 0
      currentFours = currentBrief.fours || 0
      currentSixes = currentBrief.sixes || 0

      // If team current fours is less than updated fours then fire kvevent=four event
      if (currentFours < updatedFours) {
        kvevent = 'four'
      }

      // If team current sixes is less than updated sixes then fire kvevent=six event
      if (currentSixes < updatedSixes) {
        kvevent = 'six'
      }

      /**
      * Looping through all the batsmen from current and updated props and checking
      * if their score is 50 or 100 and firing respective event
      */
      if (currentWickets === updatedWickets) {
        updatedLiteBatsmen.forEach((updateBatsman = {}) => {
          updatedBatsmanPlayerId = updateBatsman.playerid
          currentLiteBatsmen.forEach((currentBatsman = {}) => {
            if (updatedBatsmanPlayerId === currentBatsman.playerid) {
              selectedBatsman = currentBatsman
            }
          })
          currentBatsmanRuns = selectn('stats[0].value', selectedBatsman) || 0
          updatedBatsmanRuns = selectn('stats[0].value', updateBatsman) || 0
          if (currentBatsmanRuns < 50 && updatedBatsmanRuns >= 50) {
            kvevent = 'bat50'
          } else if (currentBatsmanRuns < 100 && updatedBatsmanRuns >= 100) {
            kvevent = 'bat100'
          }
        })
      }

      kvevent = generateScoreEvent(currentRuns, updatedRuns) || kvevent

      /**
      * If wickets from previous props is less than
      * wickets in updated props then check for count and
      * send respective event else fire kvevent=wicket
      */
      if (currentWickets < updatedWickets) {
        kvevent = generateWicketEvent(updatedWickets)
      }

      /**
      * If game status text from current props is not equal to game status
      * text in updated props then do check and fire respective events
      */
      kvevent = generateGameStatusEvent(currentGameStatusText, updatedGameStatusText) || kvevent

    }

    // If toss status from current props is true then fire the kvevent=toss event
    if (updatedProps.tossStatus === true) {
      kvevent = 'toss'
    }

  }

  return kvevent
}



// WEBPACK FOOTER //
// ../app/lib/utils/common.js